import difference from 'lodash/difference';
import { createErrorWithCause } from '@/utils/createErrorWithCause';

abstract class AbstractAnalyticsProvider {
  track(payload: unknown): void {
    throw createErrorWithCause(`Method track is not implemented in class ${this.constructor.name}`, payload);
  }

  validateRequiredFields(requiredFields: string[] = [], payload: Record<string, string> = {}): void {
    const misssedFields = difference(requiredFields, Object.keys(payload));

    if (misssedFields.length > 0) {
      throw new Error(
        `${
          this.constructor.name
        } Provider: provide required field(s) ${misssedFields.toString()} for method trackEvent`,
      );
    }
  }
}

export default AbstractAnalyticsProvider;
